import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

export const PrivateBannerSection = () => {
  const [BannerList, setBannerList] = useState([]);
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (BannerList?.length) {
      $(".wpo-hero-items").owlCarousel({
        autoplay: true,
        smartSpeed: 300,
        margin: 0.5,
        loop: true,
        lazyLoad: true,
        autoplayHoverPause: true,
        dots: false,
        arrows: false,
        nav: false,
        center: true,
        autoWidth: false,
        autoHeight: true,
        items: 5,
        navText: [
          '<i class="ti-arrow-left"></i>',
          '<i class="ti-arrow-right"></i>',
        ],
        responsive: {
          0: {
            items: 1,
            dots: false,
            arrows: false,
            nav: false,
          },

          575: {
            items: 1,
          },
          767: {
            items: 1,
            dots: false,
          },

          992: {
            items: 5,
            dots: false,
          },

          1200: {
            items: 5,
          },
        },
      });
    }

    setTimeout(function () {
      $("#div-slider").show();
    }, 200);
    return () => {
      $(".wpo-hero-items").trigger("destroy.owl.carousel");
    };
  }, [JSON.stringify(BannerList)]);

  const fetchData = async () => {
    try {
      const list = await corefetch("Banner/GetPrivateBannerDetails");
      if (list && list.length > 0) {
        setBannerList(list);
      } else {
        setBannerList([]);
      }
    } catch (error) {
      setBannerList([]);
      console.error("Error fetching list:", error);
    }
  };

  if (!BannerList || BannerList.length == 0) {
    return null;
  }
  return (
    <section className="wpo-hero-section" id="bannerSection">
      <div className="container-fluid">
        <div className="row" style={{ height: "410px" }}>
          <div id="div-slider" style={{ display: "none" }}>
            <div className="wpo-hero-items owl-carousel">
              {BannerList.length > 0 &&
                BannerList?.map((item, index) => {
                  return (
                    <div className="wpo-hero-item" key={index}>
                      <div className="wpo-hero-img">
                        <img
                          className="banner owl-lazy"
                          data-src={`${ImageURL}${item.oldImagePath}`}
                        />
                        <div className="wpo-hero-text">
                          <div className="butn-light mt-30 mb-30">
                            <a
                              href={`/${item.eventName}`}
                              className="btn-text"
                              id="text-Dum"
                            >
                              <span className="btn-content">
                                {item.eventName}
                              </span>
                            </a>
                          </div>
                        </div>
                        <div className="hover-content">
                          <p>{item.shortDescription}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
